var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (JSON, alias, connections, metadata, technologies, technology, technologyTitle) {var catalog_title = technology ? technologyTitle + ' Authentication' : 'How to authenticate'
var catalog_description = technology ? 'Log in to your ' + technologyTitle + ' App with any Identity Provider' : 'Authenticate your users with any Identity Provider'
var catalog_subtitle = technology ? 'Log in to your ' + technologyTitle + ' app with any enterprise or social credentials store. Includes user management, single sign on, reporting and analytics, multifactor authentication and more.' : 'With any of these technologies'
var catalog_placeholder = technology ? 'Search connections' : 'Search technologies'
pug_mixins["technologyItem"] = pug_interp = function(url, button_text, type){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cli class=\"technology-list__item\"\u003E\u003Cdiv class=\"hover-content\"\u003E\u003Ca" + (pug.attr("href", url, true, true)) + "\u003E";
if (type.image) {
pug_html = pug_html + "\u003Cdiv class=\"technology__img\"\u003E\u003Cimg" + (" class=\"technology-logo__image\""+pug.attr("src", type.image, true, true)+pug.attr("alt", technology ? technologyTitle + ' Authentication with ' + type.title : type.title + ' Authentication', true, true)) + "\u003E\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv class=\"technology__img\"\u003E\u003Ci class=\"icon icon-budicon-649 technology-logo__default\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"technology__title\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003Cdiv class=\"technology__footer text-center\"\u003E\u003Ca" + (" class=\"btn btn-lg btn-success\""+pug.attr("href", url, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = button_text) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E";
};
pug_html = pug_html + "\u003Cdiv class=\"auth-catalog-index-page\"\u003E\u003Cdiv class=\"banner auth-catalog-index-page__banner\"\u003E\u003Cdiv class=\"banner__container container banner-container\"\u003E\u003Ch1 class=\"banner__title\"\u003E" + (pug.escape(null == (pug_interp = catalog_title) ? "" : pug_interp)) + "\u003C\u002Fh1\u003E\u003Ch2\u003E" + (pug.escape(null == (pug_interp = catalog_description) ? "" : pug_interp)) + "\u003C\u002Fh2\u003E\u003Cdiv class=\"banner__form\"\u003E\u003Cform class=\"technologies-search\"\u003E\u003Cinput" + (" class=\"technologies-search__input\""+" type=\"text\""+pug.attr("placeholder", catalog_placeholder, true, true)+" autofocus") + "\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"auth-catalog-index-page__content\"\u003E\u003Cdiv class=\"container\"\u003E";
if (technology) {
pug_html = pug_html + "\u003Ch2\u003EChoose your Connection\u003C\u002Fh2\u003E";
}
else
if (!technology) {
pug_html = pug_html + "\u003Ch2\u003EChoose your Platform\u003C\u002Fh2\u003E";
}
pug_html = pug_html + "\u003Cul class=\"technology-list list-unstyled\"\u003E";
// iterate technologies
;(function(){
  var $$obj = technologies;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var _technology = $$obj[pug_index0];
if (technology && technology === _technology.hash) {
// iterate _technology.connections
;(function(){
  var $$obj = _technology.connections;
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var technology_connection = $$obj[pug_index1];
// iterate connections
;(function(){
  var $$obj = connections;
  if ('number' == typeof $$obj.length) {
      for (var pug_index2 = 0, $$l = $$obj.length; pug_index2 < $$l; pug_index2++) {
        var connection = $$obj[pug_index2];
if (technology_connection === connection.hash) {
pug_mixins["technologyItem"].call({
block: function(){
pug_html = pug_html + "\u003Cspan class=\"technology__plus-title\"\u003EAuthenticate your " + (pug.escape(null == (pug_interp = technologyTitle) ? "" : pug_interp)) + " app with&nbsp;\u003C\u002Fspan\u003E\u003Cspan class=\"technology__the-title\"\u003E" + (pug.escape(null == (pug_interp = connection.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
}, '/' + alias + '/' + _technology.hash + '/' + connection.hash, 'Quick tutorial', connection);
}
      }
  } else {
    var $$l = 0;
    for (var pug_index2 in $$obj) {
      $$l++;
      var connection = $$obj[pug_index2];
if (technology_connection === connection.hash) {
pug_mixins["technologyItem"].call({
block: function(){
pug_html = pug_html + "\u003Cspan class=\"technology__plus-title\"\u003EAuthenticate your " + (pug.escape(null == (pug_interp = technologyTitle) ? "" : pug_interp)) + " app with&nbsp;\u003C\u002Fspan\u003E\u003Cspan class=\"technology__the-title\"\u003E" + (pug.escape(null == (pug_interp = connection.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
}, '/' + alias + '/' + _technology.hash + '/' + connection.hash, 'Quick tutorial', connection);
}
    }
  }
}).call(this);

      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var technology_connection = $$obj[pug_index1];
// iterate connections
;(function(){
  var $$obj = connections;
  if ('number' == typeof $$obj.length) {
      for (var pug_index3 = 0, $$l = $$obj.length; pug_index3 < $$l; pug_index3++) {
        var connection = $$obj[pug_index3];
if (technology_connection === connection.hash) {
pug_mixins["technologyItem"].call({
block: function(){
pug_html = pug_html + "\u003Cspan class=\"technology__plus-title\"\u003EAuthenticate your " + (pug.escape(null == (pug_interp = technologyTitle) ? "" : pug_interp)) + " app with&nbsp;\u003C\u002Fspan\u003E\u003Cspan class=\"technology__the-title\"\u003E" + (pug.escape(null == (pug_interp = connection.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
}, '/' + alias + '/' + _technology.hash + '/' + connection.hash, 'Quick tutorial', connection);
}
      }
  } else {
    var $$l = 0;
    for (var pug_index3 in $$obj) {
      $$l++;
      var connection = $$obj[pug_index3];
if (technology_connection === connection.hash) {
pug_mixins["technologyItem"].call({
block: function(){
pug_html = pug_html + "\u003Cspan class=\"technology__plus-title\"\u003EAuthenticate your " + (pug.escape(null == (pug_interp = technologyTitle) ? "" : pug_interp)) + " app with&nbsp;\u003C\u002Fspan\u003E\u003Cspan class=\"technology__the-title\"\u003E" + (pug.escape(null == (pug_interp = connection.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
}, '/' + alias + '/' + _technology.hash + '/' + connection.hash, 'Quick tutorial', connection);
}
    }
  }
}).call(this);

    }
  }
}).call(this);

}
else
if (!technology) {
pug_mixins["technologyItem"].call({
block: function(){
pug_html = pug_html + "\u003Cspan class=\"technology__plus-title\"\u003EAuthenticate your&nbsp;\u003C\u002Fspan\u003E\u003Cspan class=\"technology__the-title\"\u003E" + (pug.escape(null == (pug_interp = _technology.title) ? "" : pug_interp)) + "\u003Cspan\u003E app\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E";
}
}, '/' + alias + '/' + _technology.hash, 'Show connections', _technology);
}
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var _technology = $$obj[pug_index0];
if (technology && technology === _technology.hash) {
// iterate _technology.connections
;(function(){
  var $$obj = _technology.connections;
  if ('number' == typeof $$obj.length) {
      for (var pug_index4 = 0, $$l = $$obj.length; pug_index4 < $$l; pug_index4++) {
        var technology_connection = $$obj[pug_index4];
// iterate connections
;(function(){
  var $$obj = connections;
  if ('number' == typeof $$obj.length) {
      for (var pug_index5 = 0, $$l = $$obj.length; pug_index5 < $$l; pug_index5++) {
        var connection = $$obj[pug_index5];
if (technology_connection === connection.hash) {
pug_mixins["technologyItem"].call({
block: function(){
pug_html = pug_html + "\u003Cspan class=\"technology__plus-title\"\u003EAuthenticate your " + (pug.escape(null == (pug_interp = technologyTitle) ? "" : pug_interp)) + " app with&nbsp;\u003C\u002Fspan\u003E\u003Cspan class=\"technology__the-title\"\u003E" + (pug.escape(null == (pug_interp = connection.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
}, '/' + alias + '/' + _technology.hash + '/' + connection.hash, 'Quick tutorial', connection);
}
      }
  } else {
    var $$l = 0;
    for (var pug_index5 in $$obj) {
      $$l++;
      var connection = $$obj[pug_index5];
if (technology_connection === connection.hash) {
pug_mixins["technologyItem"].call({
block: function(){
pug_html = pug_html + "\u003Cspan class=\"technology__plus-title\"\u003EAuthenticate your " + (pug.escape(null == (pug_interp = technologyTitle) ? "" : pug_interp)) + " app with&nbsp;\u003C\u002Fspan\u003E\u003Cspan class=\"technology__the-title\"\u003E" + (pug.escape(null == (pug_interp = connection.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
}, '/' + alias + '/' + _technology.hash + '/' + connection.hash, 'Quick tutorial', connection);
}
    }
  }
}).call(this);

      }
  } else {
    var $$l = 0;
    for (var pug_index4 in $$obj) {
      $$l++;
      var technology_connection = $$obj[pug_index4];
// iterate connections
;(function(){
  var $$obj = connections;
  if ('number' == typeof $$obj.length) {
      for (var pug_index6 = 0, $$l = $$obj.length; pug_index6 < $$l; pug_index6++) {
        var connection = $$obj[pug_index6];
if (technology_connection === connection.hash) {
pug_mixins["technologyItem"].call({
block: function(){
pug_html = pug_html + "\u003Cspan class=\"technology__plus-title\"\u003EAuthenticate your " + (pug.escape(null == (pug_interp = technologyTitle) ? "" : pug_interp)) + " app with&nbsp;\u003C\u002Fspan\u003E\u003Cspan class=\"technology__the-title\"\u003E" + (pug.escape(null == (pug_interp = connection.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
}, '/' + alias + '/' + _technology.hash + '/' + connection.hash, 'Quick tutorial', connection);
}
      }
  } else {
    var $$l = 0;
    for (var pug_index6 in $$obj) {
      $$l++;
      var connection = $$obj[pug_index6];
if (technology_connection === connection.hash) {
pug_mixins["technologyItem"].call({
block: function(){
pug_html = pug_html + "\u003Cspan class=\"technology__plus-title\"\u003EAuthenticate your " + (pug.escape(null == (pug_interp = technologyTitle) ? "" : pug_interp)) + " app with&nbsp;\u003C\u002Fspan\u003E\u003Cspan class=\"technology__the-title\"\u003E" + (pug.escape(null == (pug_interp = connection.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
}, '/' + alias + '/' + _technology.hash + '/' + connection.hash, 'Quick tutorial', connection);
}
    }
  }
}).call(this);

    }
  }
}).call(this);

}
else
if (!technology) {
pug_mixins["technologyItem"].call({
block: function(){
pug_html = pug_html + "\u003Cspan class=\"technology__plus-title\"\u003EAuthenticate your&nbsp;\u003C\u002Fspan\u003E\u003Cspan class=\"technology__the-title\"\u003E" + (pug.escape(null == (pug_interp = _technology.title) ? "" : pug_interp)) + "\u003Cspan\u003E app\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E";
}
}, '/' + alias + '/' + _technology.hash, 'Show connections', _technology);
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E\u003Cdiv class=\"message message--notfound\"\u003ENo matches were found.\u003C\u002Fdiv\u003E\u003Cdiv class=\"message message--tryagain\"\u003EUnable to connect with the server,\u003Ca class=\"message__link\" href=\"#\"\u003Eplease try again\u003C\u002Fa\u003E.\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Csection class=\"create-account\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cp\u003EStart your free trial today\u003C\u002Fp\u003E\u003Ca class=\"login btn btn-success btn-lg\" href=\"javascript:void(0);\" onclick=\"signup(this)\" target=\"_blank\" data-track=\"auth-catalog-index-bottom\"\u003EUse Auth0 for Free\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E\u003Cscript\u003Evar authCatalogIndex = {\n  metadata: " + (null == (pug_interp = JSON.stringify(metadata)) ? "" : pug_interp) + "\n};\u003C\u002Fscript\u003E";}.call(this,"JSON" in locals_for_with?locals_for_with.JSON:typeof JSON!=="undefined"?JSON:undefined,"alias" in locals_for_with?locals_for_with.alias:typeof alias!=="undefined"?alias:undefined,"connections" in locals_for_with?locals_for_with.connections:typeof connections!=="undefined"?connections:undefined,"metadata" in locals_for_with?locals_for_with.metadata:typeof metadata!=="undefined"?metadata:undefined,"technologies" in locals_for_with?locals_for_with.technologies:typeof technologies!=="undefined"?technologies:undefined,"technology" in locals_for_with?locals_for_with.technology:typeof technology!=="undefined"?technology:undefined,"technologyTitle" in locals_for_with?locals_for_with.technologyTitle:typeof technologyTitle!=="undefined"?technologyTitle:undefined));;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/pages/auth-catalog-index/views/main.pug
// module id = 899
// module chunks = 0